"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const GridCol_1 = __importDefault(require("./GridCol"));
exports.default = GridCol_1.default;
